import { tabClasses } from '@ori-ui/mui-bundle/material';
import breakpoints from '../breakpoints';
import { colors } from '../constants';
const styleOverrides = {
  root: ({
    theme
  }) => ({
    textTransform: 'none',
    minWidth: 'unset',
    minHeight: 'unset',
    fontSize: theme.typography.body1.fontSize,
    padding: '10px 4px',
    marginRight: 20,
    [breakpoints.up('md')]: {
      minWidth: 'unset',
      marginRight: 60,
      fontSize: '2rem',
      padding: '12px 4px'
    },
    [breakpoints.up('lg')]: {
      fontSize: '2rem'
    },
    '&:last-child': {
      marginRight: 0
    }
  }),
  textColorPrimary: {
    color: colors.oriGrey[600],
    [`&.${tabClasses.selected}`]: {
      color: colors.text.primary
    }
  }
};
const defaultProps = {
  disableRipple: true
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiTab.js.map